module.exports = __webpack_public_path__ + "static/docsBackDesktop@2x-5a6e4bddf4ad0b8eabc2b275497841ae.png";